import type { InvestmentBenchmarkDTO } from "@eu.mdotm.api/sphere";
import { assocStatusToEntity } from "$root/components/Portfolio/CreatePortfolio/constraints/const";

export function createPrimaryBenchmarkLabel(benchmark: InvestmentBenchmarkDTO): string {
	if (!benchmark.available && benchmark.status === "READY") {
		return `${benchmark.benchmarkName ?? ""} (Temporal inconsistency)`;
	}

	return assocStatusToEntity(benchmark.benchmarkName, benchmark.status);
}

export function unifyReferenceAndCustomBenchmark<
	T extends "STANDARD_BENCHMARK" | "CUSTOM_BENCHMARK" | "REFERENCE_INVESTMENT" | "CURRENT_PORTFOLIO",
>(
	type: T,
	isLabelledBenchmark?: boolean,
): "STANDARD_BENCHMARK" | "CUSTOM_BENCHMARK" | "REFERENCE_INVESTMENT" | "CURRENT_PORTFOLIO" {
	if (type === "REFERENCE_INVESTMENT" && isLabelledBenchmark) {
		return "CUSTOM_BENCHMARK";
	}

	return type;
}
